import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

interface ProductLike {
  desireid?: number | string | null;
  id?: number | string | null;
  brand_id?: number | string | null;
  brands?: Array<{ id?: number | string | null }> | null;
}

export const buildProductDetailPath = (product?: ProductLike): string | null => {
  const productId = product?.desireid ?? product?.id;
  const brandId = product?.brand_id ?? product?.brands?.[0]?.id;
  if (productId == null || brandId == null) return null;
  return `/products/${brandId}?productId=${productId}`;
};

export const useProductDetailLink = () => {
  const navigate = useNavigate();

  const goToProduct = (product?: ProductLike) => {
    const path = buildProductDetailPath(product);
    if (path) {
      navigate(path);
      return;
    }
    const productId = product?.desireid ?? product?.id;
    const brandId = product?.brand_id ?? product?.brands?.[0]?.id;
    if (productId != null && brandId == null) {
      toast.error("Please add a brand to this product");
    }
  };

  return { goToProduct, buildProductDetailPath };
};
